module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (_vm.img_string == "關閉照片") ? _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plt_no),
      expression: "plt_no"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plt_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plt_no = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carName),
      expression: "carName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.carTypes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.car_name
      }
    }, [_vm._v(_vm._s(item.car_name))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.breakLaw
    }
  }, [_vm._v("確認認證")])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.uncertain
    }
  }, [_vm._v("無法開單")]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.pass
    }
  }, [_vm._v("未違規")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-10"
  }, [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('kbd', [_vm._v("車牌號碼")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('kbd', [_vm._v("車別")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-add043c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/ShoulderCheckDetail.vue
// module id = 1536
// module chunks = 1